import React from 'react';
import { Grid, GridSize, TextField } from '@mui/material';
import { InventoryField } from 'common/modules/inventory';

interface Props {
	fields: InventoryField[];
	fieldValues: {
		[fieldId: string]: string | number;
	};
	setFieldValues: (values: { [fieldId: string]: string | number }) => void;
	fieldColSizes?: {
		xs?: GridSize;
		sm?: GridSize;
		md?: GridSize;
		lg?: GridSize;
	};
}
const SpecificationsList = (props: Props) => {
	const colSizes = props.fieldColSizes;

	const getColSize = (size: 'xs' | 'sm' | 'md' | 'lg') => {
		switch (size) {
			case 'lg':
				return colSizes?.lg ?? colSizes?.md ?? colSizes?.sm ?? colSizes?.xs ?? 4;
			case 'md':
				return colSizes?.md ?? colSizes?.sm ?? colSizes?.xs ?? 6;
			case 'sm':
				return colSizes?.sm ?? colSizes?.xs ?? 12;
			case 'xs':
				return colSizes?.xs ?? 12;
			default:
				return 12;
		}
	};

	return (
		<Grid container spacing={2}>
			{props.fields.map((field) => {
				return (
					<Grid
						key={field.id}
						item
						xs={getColSize('xs')}
						sm={getColSize('sm')}
						md={getColSize('md')}
						lg={getColSize('lg')}
					>
						<TextField
							key={field.id}
							label={field.label}
							value={props.fieldValues[field.id] || ''}
							onChange={(e) =>
								props.setFieldValues({ ...props.fieldValues, [field.id]: e.target.value })
							}
							margin="none"
							type="text"
							variant="outlined"
							fullWidth
						/>
					</Grid>
				);
			})}
		</Grid>
	);
};

export default SpecificationsList;
